export const CARET_DOWN_ICON = 'caret-down';
export const EDIT_PEN = 'pen';
export const CIRCLE_EXCLAMATION = 'circle-exclamation';
